import { supabase } from "@/integrations/supabase/client";
import type { CompanyMember } from "@/components/AssigneePicker";

/**
 * Fetch company members via the edge function.
 * Always sends the current user's access token explicitly — without a live
 * session the client would send the publishable key as the bearer, which the
 * function rejects with 401 ("invalid claim: missing sub claim").
 */
export async function fetchCompanyMembers(): Promise<CompanyMember[]> {
  const { data: sessionData } = await supabase.auth.getSession();
  const token = sessionData.session?.access_token;
  if (!token) return [];

  const { data, error } = await supabase.functions.invoke("list-company-members", {
    body: {},
    headers: { Authorization: `Bearer ${token}` },
  });
  if (error || !data?.members) return [];
  return data.members as CompanyMember[];
}
